import * as t from "io-ts";

export const Reward = t.intersection([
  t.type({
    name: t.string,
  }),
  t.partial({
    signups: t.number,
    subscribers: t.number,
    verifications: t.number,
    activations: t.number,
    rates_reduction_pct: t.number,
    rates_reduction_value: t.number,
    referral_commission_pct: t.number,
    referral_commission_value: t.number,
  }),
]);

export interface Reward {
  name: string;
  signups?: number;
  subscribers?: number;
  verifications?: number;
  activations?: number;
  rates_reduction_pct?: number;
  rates_reduction_value?: number;
  referral_commission_pct?: number;
  referral_commission_value?: number;
}
